import { useQuery, UseQueryResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";

interface EventRegistrationsParams {
  eventId: number;
  companyId: number;
}

export function useEventRegistrationsQuery(
  params: EventRegistrationsParams,
): UseQueryResult<any, Error> {
  return useQuery(
    ["app", "events", "registrations", params.eventId, params.companyId],
    () =>
      httpClient
        .get(ApiRoutes.EventRegistrations, { params })
        .then(({ data }) => data),
    { enabled: !!params.eventId && !!params.companyId },
  );
}